import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '../auth/AuthContext';
import type { FetchFormResponse } from '../service/types';
import { Query } from '../types';
import { fetchForm } from '../service/form';

export const useFormData = () => {
  const { fetchJWT } = useAuthContext();

  return useQuery<FetchFormResponse, Error>({
    queryKey: [Query.FormData],
    queryFn: async () => {
      const token = (await fetchJWT()).idToken;
      if (!token) {
        console.log('useFormData not authenticated, token:', token);
        throw Error('Not authenticated');
      }
      const response = await fetchForm(token);
      return response;
    },
    staleTime: Number.POSITIVE_INFINITY,
  });
};
